module.exports = __webpack_public_path__ + "img/mark-pattern-green.99300bf.svg";